import { render } from "./SingleMatchResult.vue?vue&type=template&id=5a722bd4&scoped=true"
import script from "./SingleMatchResult.vue?vue&type=script&lang=js"
export * from "./SingleMatchResult.vue?vue&type=script&lang=js"

import "./SingleMatchResult.vue?vue&type=style&index=0&id=5a722bd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a722bd4"]])

export default __exports__